<template>
  <div class="flex items-center justify-center p-[7.9%]" :data-product-image-src="props.src">
    
    <img
      v-if="isDevMode"
      class="w-full"
      :src="resolvedSrc"
      @error="handleImgError"
    />
    <TwicImg
      v-else-if="!failedLoad"
      refit
      class="w-full"
      :src="resolvedSrc"      
       mode="contain"            
      intrinsic="611x694"
      eager="true"
      placeholder="none"
      @stateChange="handleStateChange"
    />
    <TwicImg
      v-else
      refit
      class="w-full"
      :src="placeholderSrc"
      auto="format,compress"
      ratio="133/151"
      mode="contain"
      sizes="(min-width: 1000px) 50vw, 96vw"
      @stateChange="handleStateChange"
    />
  </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { useRuntimeConfig } from '#app'

const emit = defineEmits(['error'])

const pendingLoad = ref(true)
const failedLoad = ref(false)

function handleStateChange({ state }) {
  switch (state) {
    case 'done':
      pendingLoad.value = false
      break
    case 'error':
      failedLoad.value = true
      emit('error', props.src)
      break
    case 'loading':
      // Optionally set pendingLoad true here
      break
    default:
      // Do nothing
  }
}

function handleImgError() {
  failedLoad.value = true
  emit('error', props.src)
}

const props = defineProps({
  src: { 
    type: String, required: true 
  },
  ratio: {
    type: String,
    default: '133/151'
  }
})
const config = useRuntimeConfig()
const isDevMode = import.meta.dev
const resolvedSrc = computed(() =>
  props.src + '?deployment=' + config.public.appVersion
)
const placeholderSrc = computed(() =>
  '/images/placeholder.png' + '?deployment=' + config.public.appVersion
)

watch(
  () => props.src,
  () => {
    // Reset error status when src changes
    failedLoad.value = false
    pendingLoad.value = true
  }
)
</script>
